'use es6';

import createHocName from 'dashboard-components/decorator/createHocName';
import curry from 'transmute/curry';
import ErrorBoundary from '../components/shared/ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
export default curry((onError, ErrorComponent, Comp) => {
  const ComponentWithErrorBoundary = props => /*#__PURE__*/_jsx(ErrorBoundary, {
    onError: onError,
    ErrorComponent: ErrorComponent,
    children: /*#__PURE__*/_jsx(Comp, Object.assign({}, props))
  });
  ComponentWithErrorBoundary.displayName = createHocName('withErrorBoundary', Comp);
  return ComponentWithErrorBoundary;
});